import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../overlay/Dialog';
import {Tabs, Tab} from 'material-ui/Tabs';
import RaisedButton from 'material-ui/RaisedButton';
import QueueDialogItemFilter from './QueueDialogItemFilter';
import QueueDialogItemView from './QueueDialogItemView';
import CircularProgress from 'material-ui/CircularProgress';
import queries from '../../graphql/queries';
import mutations from '../../graphql/mutations';
import OverlayController from '../overlay/OverlayController';
import {fromJS} from 'immutable';
import { compose } from 'react-apollo';
import update from 'immutability-helper';
import './QueueDialog.css';
import QueueDialogActionButtons from "./QueueDialogActionButtons";

export default compose(
    queries.projectQueryHoc,
    mutations.createQueueMutationHoc,
    mutations.updateQueueMutationHoc,
    mutations.deleteQueueMutationHoc,
    mutations.createQueueItemButtonMutationHoc,
    mutations.updateQueueItemButtonMutationHoc,
    mutations.deleteQueueItemButtonMutationHoc
)(class extends React.Component {

    static propTypes = {
        projectId: PropTypes.string.isRequired,
        boardId: PropTypes.string,
        queue: PropTypes.object,
        stateIdsIncluded: PropTypes.array,
        stateIdsExcluded: PropTypes.array,
        onSaveSuccess: PropTypes.func
    };

    static defaultProps = {
        boardId: null,
        queue: null
    };

    constructor(props) {
        super(props);

        let boardId = props.boardId;
        let queue = props.queue;

        let state = {
            projectId: props.projectId,
            queueId: null,
            itemListViewTemplate: null,
            itemViewButtons: [],
            queueData: {
                name: '',
                boardId: null,
                query: null,
                stateIdsIncluded: [],
                stateIdsExcluded: [],
                excludeAllStates: false,
                flowIdsAssigned: [],
                flowIdsUnassigned: []
            }
        };

        if (queue) {
            state.canChangeBoardId = false;
            state.queueId = queue.id;
            state.itemListViewTemplate = queue.itemListViewTemplate;
            state.queueData.name = queue.name;
            state.queueData.boardId = queue.boardId;
            if (queue.itemFilter) {
                state.queueData.stateIdsIncluded = queue.itemFilter.stateIdsIncluded || [];
                state.queueData.stateIdsExcluded = queue.itemFilter.stateIdsExcluded || [];
                state.queueData.excludeAllStates = queue.itemFilter.excludeAllStates || false;
                state.queueData.flowIdsAssigned = queue.itemFilter.flowIdsAssigned || [];
                state.queueData.flowIdsUnassigned = queue.itemFilter.flowIdsUnassigned || [];
            }
            if (queue.itemViewButtons) {
                state.itemViewButtons = queue.itemViewButtons;
            }
            if (queue.query) {
                state.queueData.query = fromJS({
                    type: queue.query.type,
                    query: queue.query.query
                });
            }
        } else {
            state.canChangeBoardId = boardId === null;
            state.queueData.boardId = boardId;
            if (props.stateIdsIncluded) {
                state.queueData.stateIdsIncluded = props.stateIdsIncluded;
            }
            if (props.stateIdsExcluded) {
                state.queueData.stateIdsExcluded = props.stateIdsExcluded;
            }
        }

        this.state = state;
    }

    onQueueDataChange(queueData) {
        this.setState({
            queueData: update(this.state.queueData, {$merge: queueData})
        });
    }

/*
    didChangeQueueQuery(event) {
        let query = event.target.value;
        this.setState({
            query: {
                type: 'JMESPATH',
                query: query
            }
        });
    }
*/

    onQueueTemplateChange(itemListViewTemplate) {
        this.setState({itemListViewTemplate});
    }

    onItemViewButtonsChange(itemViewButtons) {
        this.state({itemViewButtons});
    }

    didSubmit(event) {
        event.preventDefault();
        OverlayController.showActivityIndicator();

        let template = this.state.itemListViewTemplate && this.state.itemListViewTemplate.template.trim();
        let itemListViewTemplate = null;
        if (template) {
            itemListViewTemplate = {
                type: this.state.itemListViewTemplate.type,
                template: template
            };
        }

        let stateIdsIncluded = [];
        let stateIdsExcluded = [];
        let excludeAllStates = this.state.queueData.excludeAllStates;
        if (!excludeAllStates) {
            stateIdsIncluded = this.state.queueData.stateIdsIncluded;
            stateIdsExcluded = this.state.queueData.stateIdsExcluded;
        }

        let query = null;
        if (this.state.queueData.query) {
            query = this.state.queueData.query;
        }

        let queueInput = {
            projectId: this.state.projectId,
            name: this.state.queueData.name.trim(),
            boardId: this.state.queueData.boardId,
            itemListViewTemplate: itemListViewTemplate,
            query: query,
            itemFilter: {
                stateIdsIncluded: stateIdsIncluded,
                stateIdsExcluded: stateIdsExcluded,
                excludeAllStates: excludeAllStates,
                flowIdsAssigned: this.state.queueData.flowIdsAssigned,
                flowIdsUnassigned: this.state.queueData.flowIdsUnassigned
            }
            // query: this.state.query.query ? {
            //     type: this.state.query.type,
            //     query: this.state.query.query
            // } : null,
        };

        let promise;
        let queueId;
        if (this.state.queueId) {
            queueId = this.state.queueId;
            promise = this.props.updateQueue(queueId, queueInput).then(({data}) => data.updateQueue);
        } else {
            promise = this.props.createQueue(queueInput).then(({data}) => data.createQueue);
        }

        promise
            .then((queue) => {
                let promises = this.state.itemViewButtons.map(itemViewButton => {
                    if (itemViewButton.removed) {
                        return this.props.deleteQueueItemButton(queueId, itemViewButton.id);
                    }
                    let queueItemButtonInput = {
                        title: itemViewButton.title,
                        eventName: itemViewButton.eventName,
                        flowIdForUserAssignment: itemViewButton.flowIdForUserAssignment
                    };
                    if (!itemViewButton.id) {
                        queueId = queue.id;
                        return this.props.createQueueItemButton(queueId, queueItemButtonInput);
                    } else if (itemViewButton.hasChanged) {
                        return this.props.updateQueueItemButton(itemViewButton.id, queueItemButtonInput);
                    } else {
                        return Promise.resolve();
                    }
                });
                return Promise.all([queue].concat(promises));
            })
            .then(([queue]) => {
                OverlayController.hideActivityIndicator();
                // hide the QueueDialog
                OverlayController.hideOverlay();
                if (this.props.onSaveSuccess) {
                    this.props.onSaveSuccess(queue);
                }
            })
            .catch((error) => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    didClickDeleteButton() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Delete', handler: this.didClickDeleteApproveButton.bind(this)}
        ];
        OverlayController.showOverlay({
            component: <Dialog title={`Are you sure you want to delete ${this.state.queueData.name} queue`} actions={actions} />
        });
    }

    didClickDeleteApproveButton() {
        OverlayController.hideOverlay();
        OverlayController.showActivityIndicator();
        this.props.deleteQueue(this.state.queueId)
            .then(({data}) => {
                console.log('got data', data);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
            })
            .catch((error) => {
                console.log('there was an error sending the query', error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    isSaveButtonDisabled() {
        let queueNameEmpty = this.state.queueData.name.trim().length === 0;
        let noBoardId = this.state.queueData.boardId === null;
        return queueNameEmpty || noBoardId;
    }

    render() {
        if (this.props.data.loading) {
            return (
                <CircularProgress className="activityIndicator"/>
            )
        } else if (this.props.data.error) {
            return (<div>{this.props.data.error.message}</div>)
        }
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Save', type: "submit", handler: this.didSubmit.bind(this), disabled: this.isSaveButtonDisabled()}
        ];
        let itemViewButtons = this.state.itemViewButtons.filter(button => !button.removed);
        return (
            <Dialog showTitleBar={true} title={`Queue`} actions={actions} className="queueDialog">
                <Tabs inkBarStyle={{height: 4, marginTop: -4}} className="queueDialogTabs" contentContainerClassName="queueDialogTabsContentContainer">
                    <Tab label="Items Filter">
                        <QueueDialogItemFilter
                            canChangeBoardId={this.state.canChangeBoardId}
                            project={this.props.data.project}
                            queueData={this.state.queueData}
                            onQueueDataChange={this.onQueueDataChange.bind(this)}/>
                    </Tab>
                    <Tab label="Items View">
                        <QueueDialogItemView
                            itemListViewTemplate={this.state.itemListViewTemplate}
                            onQueueTemplateChange={this.onQueueTemplateChange.bind(this)}/>
                    </Tab>
                    {itemViewButtons.length > 0 &&
                    <Tab label="Action Buttons">
                        <QueueDialogActionButtons
                            project={this.props.data.project}
                            itemViewButtons={itemViewButtons}
                            onItemViewButtonsChange={this.onItemViewButtonsChange.bind(this)}/>
                    </Tab>
                    }
                    {this.state.queueId &&
                    <Tab label="Danger Zone">
                        <div style={{textAlign: "center"}}>
                            <RaisedButton className="queue-delete-button" label="Delete Queue" secondary={true} onTouchTap={this.didClickDeleteButton.bind(this)}/>
                        </div>
                    </Tab>
                    }
                </Tabs>
            </Dialog>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/queue/QueueDialog.js